var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeIconEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 1.36523C10.0455 1.36523 8.78072 2.41202 8 3.89695C7.21934 2.41211 5.95456 1.36523 4.25 1.36523C1.79347 1.36523 0 3.4282 0 5.94383C0 9.27061 3.17412 11.3592 7.69131 15.3117C7.86809 15.4664 8.13191 15.4664 8.30869 15.3117C12.8217 11.3628 16 9.27102 16 5.94383C16 3.4278 14.2062 1.36523 11.75 1.36523ZM8 14.3371C3.83994 10.7235 0.9375 8.71614 0.9375 5.94383C0.9375 3.86808 2.36156 2.30273 4.25 2.30273C6.07037 2.30273 7.19847 3.98858 7.54819 5.24011C7.67431 5.69667 8.32413 5.6987 8.45181 5.24011C8.79691 4.00517 9.91191 2.30273 11.75 2.30273C13.6384 2.30273 15.0625 3.86808 15.0625 5.94383C15.0625 8.71773 12.1553 10.7277 8 14.3371Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIconEmpty);
export default __webpack_public_path__ + "static/media/likeIconEmpty.6398e5ec.svg";
export { ForwardRef as ReactComponent };